import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
  useContext,
  useCallback,
} from 'react'

type InspectItem = string | null

const context = createContext<
  [InspectItem, Dispatch<SetStateAction<InspectItem>>]
>([null, () => {}])

export const InspectContextProvider: React.FC = ({ children }) => {
  const value = useState<string | null>(null)

  return <context.Provider value={value}>{children}</context.Provider>
}

export function useInspectContext() {
  const [inspectItem, setInspectItem] = useContext(context)

  const handleSelectItem = useCallback(
    (identifier: string | null) => {
      setInspectItem(inspectItem =>
        inspectItem === identifier ? null : identifier
      )
    },
    [setInspectItem]
  )

  return { selectedItem: inspectItem, handleSelectItem }
}
